const stages = [
  { num: "I", title: "Discover", desc: "First rally to court awareness." },
  { num: "II", title: "Build", desc: "Tactical depth. Fitness integration." },
  { num: "III", title: "Compete", desc: "Tournament preparation. Rankings." },
  { num: "IV", title: "Excel", desc: "National contention. College pathway." },
];

const PlayerPathway = () => (
  <section className="section" style={{ background: "var(--lrg-surface)" }} data-testid="pathway-section">
    <div className="container-custom">
      <div className="max-w-md mb-20">
        <p className="overline mb-5">Player Pathway</p>
        <h2 className="font-editorial text-4xl sm:text-5xl font-medium text-[#F2EDE4] leading-[1.1]">
          The progression.
        </h2>
      </div>

      <div className="flex flex-col md:flex-row">
        {stages.map((s, i) => (
          <div key={s.num} className="flex-1 py-10 md:px-10 border-b md:border-b-0 md:border-r border-[#1D1F21] last:border-0 group" data-testid={`stage-${i}`}>
            <span className="font-editorial text-5xl text-[#1D1F21] group-hover:text-[#0D6B56]/20 transition-colors duration-700 block mb-8">{s.num}</span>
            <h3 className="font-display text-sm font-semibold text-[#F2EDE4] uppercase tracking-[0.1em] mb-3">{s.title}</h3>
            <p className="text-[11px] text-[#3A3D40] leading-[1.8]">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PlayerPathway;
